import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=b463f81c&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./loading.vue?vue&type=style&index=0&id=b463f81c&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b463f81c",
  "25d84b8b"
  
)

export default component.exports